import type { Winner } from '@src/@types/ozonPrizeWinners';
import winnerFemaleSrc from '@src/assets/octoberPrizeDraw/avatars/winnerFemale.png';
import winnerMaleSrc from '@src/assets/octoberPrizeDraw/avatars/winnerMale.png';

const AMOUNT = '50 000 ₽';

// ФИО добавить в формате 'Иван Ч.'
export const SECONDARY_WINNER_LIST: Winner[] = [
  {
    id: 2,
    phoneNumber: '+79829150139',
    amount: AMOUNT,
    avatarSrc: winnerMaleSrc,
    fio: '',
  },
  {
    id: 3,
    phoneNumber: '+79066788445',
    amount: AMOUNT,
    avatarSrc: winnerFemaleSrc,
    fio: '',
  },
  {
    id: 4,
    phoneNumber: '+79170443351',
    amount: AMOUNT,
    avatarSrc: winnerMaleSrc,
    fio: '',
  },
  {
    id: 5,
    phoneNumber: '+79507418970',
    amount: AMOUNT,
    avatarSrc: winnerFemaleSrc,
    fio: '',
  },
  {
    id: 6,
    phoneNumber: '+79286446060',
    amount: AMOUNT,
    avatarSrc: winnerMaleSrc,
    fio: '',
  },
];
